import { createRoute } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { siteRoute } from '../layouts';

const formsComp = lazyPage(() => import('./pages'), 'FormsAppHost');

const formsIndexRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'forms',
  component: formsComp,
  staticData: { title: 'forms.forms', fullBleed: true },
});

// The forms SPA owns every path below /forms, so the host matches them all onto the same mount.
const formsCatchAllRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'forms/$',
  component: formsComp,
  staticData: { title: 'forms.forms', fullBleed: true },
});

/** Forms family leaves to attach under the site-env layout. */
export const formsLeaves = [formsIndexRoute, formsCatchAllRoute];
